import React from 'react';
import { Container } from 'react-bootstrap';
import AppHeader from '../../components/Common/AppHeader';
import AppFooter from '../../components/Common/AppFooter';

const TermsOfUse = () => (
  <div className="bg-light min-vh-100 d-flex flex-column">
    <AppHeader />
    <Container className="py-5 flex-grow-1 bg-white shadow-sm my-5 rounded p-5">
      <h2 className="fw-bold">Terms of Service</h2>
      <p className="text-muted">Effective Date: 31 March 2026</p>
      <hr />

      <section className="mb-4">
        <h4>1. Parties</h4>
        <p>
          AcademicOS serves institutions, independent users (SMEs), and enterprise partners. 
          Roles and responsibilities vary depending on contractual engagement.
        </p>
      </section>

      <section className="mb-4">
        <h4>2. Scope of Services</h4>
        <p>
          AcademicOS provides AI-assisted tools for curriculum design, content generation, assessment creation, 
          and instructional material development. The platform is assistive and not a substitute for human academic judgment.
        </p>
      </section>

      <section className="mb-4">
        <h4>3. Nature of AI-Generated Content</h4>
        <p>
          All outputs are AI-generated drafts and must be reviewed and validated by qualified experts. 
          AcademicOS does not guarantee accuracy, completeness, or compliance.
        </p>
      </section>

      <section className="mb-4">
        <h4>4. User Obligations</h4>
        <ul>
          <li>Use the platform lawfully</li>
          <li>Validate AI-generated outputs</li>
          <li>Maintain academic integrity</li>
          <li>Protect account credentials</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4>5. Content & Intellectual Property</h4>
        <p>
          Users are responsible for ensuring that uploaded content is legally owned or licensed. 
          AcademicOS does not verify ownership and disclaims liability for infringement.
        </p>
      </section>

      <section className="mb-4">
        <h4>6. AI Disclaimer</h4>
        <p>
          AI outputs may contain inaccuracies or similarities to source material. 
          Users must review and validate all outputs before use.
        </p>
      </section>

      <section className="mb-4">
        <h4>7. Acceptable Use</h4>
        <ul>
          <li>No unlawful or infringing content</li>
          <li>No reverse engineering</li>
          <li>No misuse of system outputs</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4>8. Data Protection</h4>
        <p>
          Data processing is governed by the Privacy Policy and applicable agreements. 
          AcademicOS may act as Processor or Controller depending on usage.
        </p>
      </section>

      <section className="mb-4">
        <h4>9. Billing & Credits</h4>
        <p>
          Usage is credit-based. Credits are non-refundable unless agreed otherwise.
        </p>
      </section>

      <section className="mb-4">
        <h4>10. Availability</h4>
        <p>
          AcademicOS aims for reliable availability but does not guarantee uninterrupted service.
        </p>
      </section>

      <section className="mb-4">
        <h4>11. Third-Party Dependencies</h4>
        <p>
          The platform depends on third-party services (e.g., cloud providers, AI APIs like Vertex AI or OpenAI). 
          AcademicOS is not liable for outages, API failures, or service disruptions caused by these dependencies.
        </p>
      </section>

      <section className="mb-4">
        <h4>12. Limitation of Liability</h4>
        <p>
          AcademicOS is not liable for AI inaccuracies, user decisions, copyright violations, or third-party outages.
        </p>
      </section>

      <section className="mb-4">
        <h4>13. Indemnification</h4>
        <p>
          Users agree to indemnify AcademicOS against claims arising from content, usage, or violations.
        </p>
      </section>

      <section className="mb-4">
        <h4>14. Termination</h4>
        <p>
          AcademicOS may suspend or terminate access for misuse, violations, or security risks.
        </p>
      </section>

      <section className="mb-4">
        <h4>15. Force Majeure</h4>
        <p>
          AcademicOS is not liable for failures caused by external events including infrastructure outages or natural disasters.
        </p>
      </section>

      <section className="mb-4">
        <h4>16. Governing Law</h4>
        <p>
          Governing law depends on contractual agreements or operating jurisdiction.
        </p>
      </section>

      <section className="mb-4">
        <h4>17. Contact</h4>
        <p>Email: info@tatvaone.ai</p>
      </section>

    </Container>
    <AppFooter />
  </div>
);

export default TermsOfUse;
